module.exports = __webpack_public_path__ + "static/img/three_bro_logo.b89f575.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/three_bro_logo.png
// module id = DbJa
// module chunks = 8